import React from 'react'
import injectSheet from 'react-jss'
import styles from './navigation.styles'
import NavLink from './nav-link/nav-link'
import User from './user/user.container'
import UserSkeleton from './user/user.skeleton'

const Navigation = ({
  classes,
  location,
  pending,
  canSeeSchoolTab,
  canSeeMembershipTab,
  canSeeMaterialTab
}) => {
  return (
    <nav className={classes.container}>
      {!pending && <User />}
      {pending && <UserSkeleton />}
      <ul className={classes.links}>
        <NavLink path="/">Profile</NavLink>
        {canSeeSchoolTab && <NavLink path="/school/team">School</NavLink>}
        {canSeeMembershipTab && (
          <NavLink path="/membership">Subscription</NavLink>
        )}
      </ul>
    </nav>
  )
}

export default injectSheet(styles)(Navigation)
